
    import I18n from '@canvas/i18n/i18nObj';
    
      import 'translations/broccoli_cloud';
      import 'translations/_core';
    
    import 'translations/_core_en';

    export default I18n.scoped('broccoli_cloud');
  